import { Badge } from "@/components/ui/badge";

// Palette unique et source de vérité : légende du calendrier, bandeaux des RDV
// et badges de statut utilisent EXACTEMENT ces couleurs. Le texte s'adapte
// automatiquement (clair/foncé) pour rester parfaitement lisible.
export const APPT_STATUS = {
  planifie:       { label: "Planifié",                color: "#64748b" }, // gris / bleu ardoise
  public_attente: { label: "RDV public en attente",   color: "#78350f" }, // brun
  devis:          { label: "Devis",                   color: "#7c3aed" }, // violet
  a_facturer:     { label: "À facturer",              color: "#f97316" }, // orange
  en_attente:     { label: "En attente de règlement", color: "#2563eb" }, // bleu
  paye:           { label: "Payé",                    color: "#16a34a" }, // vert
  annule:         { label: "Annulé",                  color: "#ec4899" }, // rose / magenta
  absent:         { label: "Absent",                  color: "#dc2626" }, // rouge
  multi_jours:    { label: "Multi-jours",             color: "#facc15" }, // jaune, texte noir
  perso:          { label: "Perso",                   color: "#111827" }, // noir, texte blanc
};

export const REQ_STATUS = {
  recue: { label: "Nouvelle demande", cls: "bg-amber-500/10 text-amber-600 border-amber-500/30" },
  date_proposee: { label: "Date proposée", cls: "bg-cyan-500/10 text-cyan-600 border-cyan-500/30" },
  acceptee: { label: "Acceptée", cls: "bg-emerald-500/10 text-emerald-600 border-emerald-500/30" },
  refusee: { label: "Refusée", cls: "bg-red-500/10 text-red-600 border-red-500/30" },
};

// Retourne du texte foncé ou clair selon la luminance du fond, pour garantir la lisibilité.
export function contrastText(hex) {
  const h = (hex || "#64748b").replace("#", "");
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  const L = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return L > 0.6 ? "#0f172a" : "#ffffff";
}

export function StatusBadge({ status, map = APPT_STATUS }) {
  const s = map[status] || { label: status };
  if (s.color) {
    return (
      <span
        className="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold"
        style={{ background: s.color, color: contrastText(s.color), borderColor: s.color }}
        data-testid={`status-${status}`}>
        {s.label}
      </span>
    );
  }
  return (
    <Badge variant="outline" className={`font-medium ${s.cls || "bg-slate-500/10 text-slate-700 border-slate-500/30"}`} data-testid={`status-${status}`}>
      {s.label}
    </Badge>
  );
}
